import PropTypes from 'prop-types';
import Slider from 'rc-slider';
import ReactSelect from 'react-select';
import classnames from 'classnames';

import {LegendHeader} from '../../../../../../../atoms/Legend';

import 'rc-slider/assets/index.css';
import './style.scss';

const marks = {
	[-10]: '< -10',
	[-9]: -9,
	[-8]: -8,
	[-7]: -7,
	[-6]: -6,
	[-5]: -5,
	[-4]: -4,
	[-3]: -3,
	[-2]: -2,
	[-1]: -1,
	0: 0,
	1: 1,
	2: 2,
	3: 3,
	4: 4,
	5: 5,
	6: 6,
	7: 7,
	8: 8,
	9: 9,
	10: <div>10 &#60;</div>,
};

const RangeControl = ({
	handleNewIntervalSelect,
	handleVisualizationCustomInterval,
	visualizations,
	handleActiveVisualizationFilteredOutInterval,
	isHidden,
}) => {
	const customStyles = {
		control: provided => ({
			...provided,
			background: 'transparent',
			minHeight: '1.5rem',
			borderColor: 'var(--base40)',
			':hover': {
				borderColor: 'var(--base60)',
			},
		}),
		container: provided => ({
			...provided,
			position: 'relative',
			fontSize: '1rem',
			borderRadius: '0.25rem',
			marginBottom: '0.75rem',
		}),
		dropdownIndicator: (provided, state) => ({
			...provided,
			padding: '0.3rem',
			cursor: 'pointer',
			color: state.isFocused ? 'var(--accent55)' : 'hsl(0, 0%, 60%)',
			':hover': {
				color: 'var(--base80)',
				backgroundColor: 'rgba(var(--base50rgb), 0.12)',
			},
		}),
		input: provided => ({
			...provided,
			fontWeight: '400',
		}),
		singleValue: provided => ({
			...provided,
			fontWeight: '500',
		}),
		valueContainer: provided => ({
			...provided,
			padding: '0px 6px',
			cursor: 'text',
		}),
		option: provided => ({
			...provided,
			cursor: 'pointer',
		}),
		menu: provided => ({
			...provided,
			position: 'fixed',
			border: '1px solid var(--base30)',
			width: 'calc(100% - 1.5rem)',
		}),
	};

	return (
		<div className="insar-visualizationControl-rangeControlWrapper">
			<div
				className={classnames('insar-visualizationControl-rangeControl', {
					'is-hidden': isHidden,
				})}
			>
				<LegendHeader title={'Control visible data range'} />
				<Slider
					className="insar-visualizationControl-slider"
					onChange={interval => {
						handleNewIntervalSelect(interval);
						handleActiveVisualizationFilteredOutInterval();
						handleVisualizationCustomInterval(interval);
					}}
					range
					value={visualizations?.data?.customInterval}
					count={1}
					defaultValue={[-10, 10]}
					allowCross={false}
					pushable
					dots
					marks={marks}
					step={1}
					min={-10}
					max={10}
					dotStyle={{
						backgroundColor: 'var(--accent45)',
						border: '2px solid var(--accent90)',
					}}
					railStyle={{backgroundColor: 'var(--accent90)'}}
					trackStyle={{backgroundColor: 'var(--accent60)'}}
				/>
				<ReactSelect
					options={[
						{value: [-2, 2], label: 'Small displacement'},
						{value: [-5, 5], label: 'Medium displacement'},
						{value: [-10, 10], label: 'Maximum displacement'},
					]}
					defaultValue={{value: [-10, 10], label: 'Maximum displacement'}}
					menuPlacement={'auto'}
					styles={customStyles}
					theme={theme => ({
						...theme,
						colors: {
							...theme.colors,
							primary25: 'var(--accent20)',
							primary50: 'var(--accent30)',
							primary: 'var(--accent50)',
							neutral0: 'var(--base10)',
							neutral20: 'var(--base40)',
							neutral80: 'var(--base80)',
							neutral90: 'var(--base90)',
						},
					})}
					onChange={option => {
						handleNewIntervalSelect(option.value);
						handleActiveVisualizationFilteredOutInterval();
						handleVisualizationCustomInterval(option.value);
					}}
				/>
			</div>
		</div>
	);
};

RangeControl.propTypes = {
	handleNewIntervalSelect: PropTypes.func,
	handleVisualizationCustomInterval: PropTypes.func,
	visualizations: PropTypes.array,
	handleActiveVisualizationFilteredOutInterval: PropTypes.func,
	isHidden: PropTypes.bool,
};

export default RangeControl;
